import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { homehandpicksList } from '../services/Product-service';

function Handpicked({ showhpdeals, sectionTitle }) {
    const [items, setItems] = useState([]);
    const [apiTitle, setApiTitle] = useState('');

    useEffect(() => {
        homehandpicksList({ home_positions: 'hand_deals',limit: 5  })
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setItems(
                    list.filter((item) => {
                        const thumb = item?.designer_thumbnail || '';
                        const cover = item?.designer_cover || '';
                        const hasThumb = thumb && /\.(jpe?g|png|webp|avif|gif)(\?|$)/i.test(thumb);
                        const hasCover = cover && /\.(jpe?g|png|webp|avif|gif)(\?|$)/i.test(cover);
                        return item?.id && (hasThumb || hasCover);
                    })
                );
                setApiTitle(data?.section_ttile || data?.section_title || '');
            })
            .catch((error) => {
                console.error('Error fetching handpicked deals:', error);
            });
    }, []);

    const layout = useMemo(() => {
        if (items.length < 2) return null;

        const imageFor = (item) => {
            const thumb = item.designer_thumbnail || '';
            const cover = item.designer_cover || '';
            const coverOk = cover && /\.(jpe?g|png|webp|avif|gif)(\?|$)/i.test(cover);
            // Prefer portrait designer thumbnails so head/body framing stays consistent
            return thumb || (coverOk ? cover : '');
        };

        const mapItem = (item) => {
            const designer = (item.designer_name || '').trim();
            const collection = (
                item.collection_name ||
                item.collection ||
                item.campaign_name ||
                item.designer_tagline ||
                ''
            ).trim();

            return {
                id: item.id,
                src: imageFor(item),
                alt: designer || 'Handpicked deal',
                link: `/category/?designer_id=${item.id}`,
                name: designer,
                subtitle: collection,
            };
        };

        const banner = items[0];
        const side = items[1];
        const bottom = items.slice(2, 5);

        return {
            banner: mapItem(banner),
            side: mapItem(side),
            bottom: bottom.map((item) => mapItem(item)),
        };
    }, [items]);

    const renderOverlay = (item) => (
        <span className="best-selling-overlay">
            {item.name ? (
                <span className="best-selling-overlay-name">{item.name}</span>
            ) : null}
            {item.subtitle ? (
                <span className="best-selling-overlay-subtitle">{item.subtitle}</span>
            ) : null}
            <span className="best-selling-overlay-cta">SHOP NOW</span>
        </span>
    );

    if (!showhpdeals || !layout) return null;

    return (
        <div className="App">
            <div className="BreakPointContainer">
                <div className="CarouselSectionContainer best-selling-designs handpicked-deals">
                    <div className="SectionTitle">
                        <h1 className="m-t-0 m-b-15 text-left demi-bold">
                            {apiTitle || sectionTitle || 'HANDPICKED DEALS'}
                        </h1>
                    </div>
                    <div className="best-selling-designs-grid">
                        <Link to={layout.banner.link} className="best-selling-banner">
                            <img
                                src={layout.banner.src}
                                alt=""
                                aria-hidden="true"
                                className="handpicked-deals-banner-fill"
                            />
                            <img
                                src={layout.banner.src}
                                alt={layout.banner.alt}
                                className="handpicked-deals-banner-photo"
                            />
                            {renderOverlay(layout.banner)}
                        </Link>
                        <Link
                            to={layout.side.link}
                            className="best-selling-card best-selling-card-side"
                        >
                            <img src={layout.side.src} alt={layout.side.alt} />
                            {renderOverlay(layout.side)}
                        </Link>
                        {layout.bottom.map((item) => (
                            <Link
                                to={item.link}
                                className="best-selling-card"
                                key={item.id}
                            >
                                <img src={item.src} alt={item.alt} />
                                {renderOverlay(item)}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Handpicked;
